var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2459 6.41471H10.7997C10.5449 6.41417 10.2969 6.49711 10.0936 6.65087C9.89035 6.80462 9.74306 7.02071 9.67425 7.2661L8.30386 12.1412C8.29503 12.1715 8.27661 12.1981 8.25138 12.217C8.22614 12.2359 8.19545 12.2462 8.1639 12.2462C8.13236 12.2462 8.10167 12.2359 8.07643 12.217C8.0512 12.1981 8.03278 12.1715 8.02395 12.1412L4.80498 0.688218C4.79615 0.657936 4.77774 0.631336 4.7525 0.612409C4.72727 0.593483 4.69657 0.583252 4.66503 0.583252C4.63348 0.583252 4.60279 0.593483 4.57756 0.612409C4.55232 0.631336 4.53391 0.657936 4.52507 0.688218L3.15468 5.56332C3.08614 5.80775 2.93972 6.02314 2.73765 6.17679C2.53558 6.33045 2.2889 6.41398 2.03504 6.41471H0.583008",
    stroke: "#99A1AF",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.5d3f505a023b2f5d8c9464cac78db9fa.svg";
export { ForwardRef as ReactComponent };